import Box from '@mui/material/Box'
import Skeleton from '@mui/material/Skeleton'
import {
  SENSEMAKER_OVERVIEW_BREADCRUMB_TO_PROFILE_GAP_PX,
  SENSEMAKER_OVERVIEW_CHARTS_TO_CAMPAIGNS_GAP_PX,
  SENSEMAKER_OVERVIEW_CHART_GAP_PX,
  SENSEMAKER_OVERVIEW_CHART_HEIGHT_PX,
  SENSEMAKER_OVERVIEW_MAJOR_SECTION_GAP_PX,
  SENSEMAKER_OVERVIEW_METRICS_TO_CHARTS_GAP_PX,
  SENSEMAKER_OVERVIEW_PROFILE_TO_METRICS_GAP_PX,
} from '../../lib/sensemaker-overview-layout'

export function SensemakerOverviewPageSkeleton() {
  return (
    <Box
      aria-busy
      aria-label="Loading Sensemaker overview"
      data-testid="sensemaker-overview-page-skeleton"
      sx={{ display: 'flex', flexDirection: 'column' }}
    >
      <Skeleton variant="rounded" height={56} width={360} sx={{ borderRadius: '8px' }} />
      <Skeleton
        variant="rounded"
        height={187}
        sx={{ borderRadius: '14px', mt: `${SENSEMAKER_OVERVIEW_BREADCRUMB_TO_PROFILE_GAP_PX}px` }}
      />
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(4, 1fr)',
          gap: '24px',
          mt: `${SENSEMAKER_OVERVIEW_PROFILE_TO_METRICS_GAP_PX}px`,
        }}
      >
        {Array.from({ length: 4 }).map((_, i) => (
          <Skeleton key={i} variant="rounded" height={174} sx={{ borderRadius: '10px' }} />
        ))}
      </Box>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: `${SENSEMAKER_OVERVIEW_CHART_GAP_PX}px`,
          mt: `${SENSEMAKER_OVERVIEW_METRICS_TO_CHARTS_GAP_PX}px`,
        }}
      >
        <Skeleton variant="rounded" height={SENSEMAKER_OVERVIEW_CHART_HEIGHT_PX} />
        <Skeleton variant="rounded" height={SENSEMAKER_OVERVIEW_CHART_HEIGHT_PX} />
      </Box>
      <Skeleton
        variant="rounded"
        height={200}
        sx={{ borderRadius: '10px', mt: `${SENSEMAKER_OVERVIEW_CHARTS_TO_CAMPAIGNS_GAP_PX}px` }}
      />
      <Skeleton
        variant="rounded"
        height={160}
        sx={{ borderRadius: '10px', mt: `${SENSEMAKER_OVERVIEW_MAJOR_SECTION_GAP_PX}px` }}
      />
      <Skeleton
        variant="rounded"
        height={120}
        sx={{ borderRadius: '10px', mt: `${SENSEMAKER_OVERVIEW_MAJOR_SECTION_GAP_PX}px` }}
      />
    </Box>
  )
}
